import apiClient from '../client';

/** { ratingsPublic, textPublic, products: [{ productId, average, count }] } — empty until the store publishes ratings. */
export const getReviewSummary = async () => {
  const { data } = await apiClient.get('/reviews/summary');
  return data;
};

/**
 * { ratingsPublic, textPublic, average, count, distribution: { '5': n … '1': n }, reviews, page, totalPages,
 *   tags: [{ id, label, kind: POSITIVE|NEGATIVE, count }] }. {@code tag} = only the reviews with that tag.
 */
export const getProductReviews = async (productId, { page = 0, size = 10, tag } = {}) => {
  const params = { page, size };
  if (tag) params.tag = tag;
  const { data } = await apiClient.get(`/products/${productId}/reviews`, { params });
  return data;
};

/** The store's rating tags: { positive: [{ id, label }] (4–5★), negative: [...] (1–3★) }. */
export const getReviewTags = async () => {
  const { data } = await apiClient.get('/reviews/tags');
  return data;
};

/** { textPublic, reviews } — approved 4–5★ reviews with text, for the home page. */
export const getReviewHighlights = async (limit = 6) => {
  const { data } = await apiClient.get('/reviews/highlights', { params: { limit } });
  return data;
};

/** Items of the signed-in customer's delivered orders, each with { review } or review: null. */
export const getMyReviewItems = async () => {
  const { data } = await apiClient.get('/account/reviews');
  return Array.isArray(data) ? data : [];
};

export const submitReview = async ({ orderItemId, rating, title, body, tagIds }) => {
  const { data } = await apiClient.post('/account/reviews', {
    orderItemId, rating, title: title?.trim() || null, body: body?.trim() || null, ...(tagIds?.length ? { tagIds } : {}),
  });
  return data;
};

/** The order behind a review e-mail link: { orderNumber, firstName, delivered, items: [{ orderItemId, title, …, review }] }. */
export const getReviewLinkOrder = async (token) => {
  const { data } = await apiClient.get('/reviews/link', { params: { t: token } });
  return data;
};

/** A rating from the review e-mail link — no sign-in, the link is the proof (that order only). */
export const submitLinkReview = async (token, { orderItemId, rating, title, body, tagIds }) => {
  const { data } = await apiClient.post('/reviews/link', {
    token, orderItemId, rating, title: title?.trim() || null, body: body?.trim() || null, ...(tagIds?.length ? { tagIds } : {}),
  });
  return data;
};
